module.exports = __webpack_public_path__ + "c9e9ef1d2ee43e67ba2cd537c3f6d7ed.svg";